module.exports = __webpack_public_path__ + "static/img/pcb-background.0efd898.svg";


//////////////////
// WEBPACK FOOTER
// ./src/SVG-filer/pcb-background.svg
// module id = vaVA
// module chunks = 1